import axios from "axios";
import qs from "qs";
const initialState = {
    sosTemplateArticle: {
        title: "",
        abstract: "",
        body: "",
        json: {},
        html: "",
        category: "kolkin",
    },
    sosTemplateCategories: [],
    sosTemplateArticles: [],
    sosTemplateArticleCount: 0,
    sosTemplateCategoryArticles: {}
};
export const state = { ...initialState };
export const actions = {
    async loadSosTemplateArticle(context,id){
        return axios.get('/api/template/blog/article',{params:{id:id}}).then(function(response){
            context.commit('sosTemplateArticleSet',response.data);
        });
    },
    resetArticle(context){
        context.commit('articleClear');
    },
    async loadSosTemplateCategories(context){
        return axios.get("/api/template/blog/category").then(function(response){
            context.commit("setSosTemplateCategories",response.data)
        })
    },
    async loadSosTemplateArticles(context,params){
        return axios.get("/api/template/blog/articles",{params: params,
        paramsSerializer(params){
	            var result = qs.stringify(params,{arrayFormat: "brackets"});
	            return result
            }
        }).then(function(response){
        	console.log("articles",response)
            context.commit("setSosTemplateArticles",response.data.articles);
            context.commit("setSosTemplateArticleCount",response.data.count);
        })
    },
    async loadMoreSosTemplateArticles(context,params){
        return axios.get("/api/template/blog/articles",{params: params,
        paramsSerializer(params){
            var result = qs.stringify(params,{arrayFormat: "brackets"});
            return result
            }
        }).then(function(response){
            context.commit("appendSosTemplateArticles",response.data.articles);
            context.commit("setSosTemplateArticleCount",response.data.count);

        })
    },

}

export const mutations = {

    articleClear(state){
        state.sosTemplateArticle =  {
            title: "",
            abstract: "",
            body: "",
            json: {},
            html: "",
            category: "kolkin",
            color: "primary",
        };
    },

    sosTemplateArticleSet(state, article){
        state.sosTemplateArticle = article;
        if(article.json){
            state.sosTemplateArticle.json = JSON.parse(article.json)
        }

    },

    articleUpdate(state, articleUpdate) {

        state.sosTemplateArticle.title = articleUpdate.title;
        state.sosTemplateArticle.abstract = articleUpdate.abstract;
        state.sosTemplateArticle.body = articleUpdate.body;
        state.sosTemplateArticle.json = articleUpdate.json;
        state.sosTemplateArticle.html = articleUpdate.html;


    },

    setSosTemplateCategories(state, data){
        state.sosTemplateCategories = data;
    },

    setSosTemplateArticles(state, data){
        state.sosTemplateArticles = data;
		state.sosTemplateCategoryArticles = {};
		for (var i = 0; i < data.length; i++){

			if(state.sosTemplateCategoryArticles[data[i].category]){
				state.sosTemplateCategoryArticles[data[i].category].push(data[i]);
			}else {
				state.sosTemplateCategoryArticles[data[i].category] = [data[i]];
			}
		}
    },

    setSosTemplateArticleCount(state,data){
        state.sosTemplateArticleCount = data;
    },

    appendSosTemplateArticles(state,data){
        state.sosTemplateArticles = state.sosTemplateArticles.concat(data);
    },

    setCategory(state,data){
        state.sosTemplateArticle.category = data;
    }

}

const getters = {
    sosTemplateArticle(state){
        return state.sosTemplateArticle;
    },

    sosTemplateArticleCount(state){
        return state.sosTemplateArticleCount;
    },

    sosTemplateArticles(state){
        return state.sosTemplateArticles;
    },

    sosTemplateCategories(state){
        return state.sosTemplateCategories
    },

    sosTemplateCategoryArticles(state){
		return state.sosTemplateCategoryArticles;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
  };
